import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { FileInput } from "src/app/models/support";

@Component({
  selector: "email-change-ticket",
  templateUrl: "./email-change-ticket.component.html",
  styleUrls: ["./email-change-ticket.component.scss"],
})
export class EmailChangeTicketComponent implements OnInit, OnChanges {
  @Input() category: string;
  @Input() form: FormGroup;
  @Input() isVisible: boolean = false;

  constructor() {}

  ngOnInit(): void {}
  onFileSelect(file: FileInput, name: string) {
    this.form.get(name).setValue({
      name: file.file.name,
      content: file.base64,
    });
  }

  onFileRemove(name: string) {
    this.form.get(name).reset();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.category) {
      if (this.isVisible) this.initiateForm();
    }
  }
  markAsTouched(name: string) {
    this.form.get(name).markAsTouched();
  }
  initiateForm() {
    this.form.addControl(
      "personalPhoto",
      new FormControl(null, [Validators.required])
    );
    this.form.addControl(
      "passport",
      new FormControl("", [Validators.required])
    );
    this.form.addControl(
      "newEmailAddress",
      new FormControl("", [Validators.required, Validators.email])
    );
    this.form.addControl("message", new FormControl(""));
  }

  get newEmailAddress() {
    return this.form.get("newEmailAddress");
  }
  get personalPhoto() {
    return this.form.get("personalPhoto");
  }

  get passport() {
    return this.form.get("passport");
  }
}
